import {
  GET_USER_HISTORY,
  GET_USER_HISTORY_SUCCESS,
  GET_USER_HISTORY_ERROR,
} from '../../../constants/constantsRed';

export const getUserHistory = (state: any = false, actions: any) => {
  switch (actions.type) {
    case GET_USER_HISTORY:
      return {
        ...state,
        loading: true,
      };
    case GET_USER_HISTORY_SUCCESS:
      return {
        data: actions.payload,
        loading: false,
        error: null,
      };
    case GET_USER_HISTORY_ERROR:
      return {
        ...state,
        loading: false,
        error: null,
        data: actions.payload,
      };
    default:
      return state;
  }
};
